// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCreateNew_root__DFu-z","text":"PlasmicCreateNew_text__QTm7X"};